"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waterScale = exports.fireScale = exports.healthScale = exports.riftScale = exports.rainbowScalePalette = exports.rainbowScale = void 0;
var rogueColors_1 = require("@dive/colors/rogueColors");
var chroma_js_1 = __importDefault(require("chroma-js"));
exports.rainbowScale = chroma_js_1.default
    .scale(['red', 'orange', 'yellow', 'green', 'blue', 'purple'])
    .colors(32)
    .map(function (c) { return chroma_js_1.default(c).num(); });
exports.rainbowScalePalette = [
    rogueColors_1.rogueColors.red,
    rogueColors_1.rogueColors.orange,
    rogueColors_1.rogueColors.yellow,
    rogueColors_1.rogueColors.green,
    rogueColors_1.rogueColors.lightBlue,
    rogueColors_1.rogueColors.darkBlue,
    rogueColors_1.rogueColors.light,
    rogueColors_1.rogueColors.peach,
    rogueColors_1.rogueColors.brown,
    rogueColors_1.rogueColors.gray,
    rogueColors_1.rogueColors.blueGray,
];
exports.riftScale = [
    rogueColors_1.rogueColors.red,
    rogueColors_1.rogueColors.orange,
    rogueColors_1.rogueColors.yellow,
    // rogueColors.green,
    rogueColors_1.rogueColors.lightBlue,
    rogueColors_1.rogueColors.darkBlue,
    rogueColors_1.rogueColors.light,
    rogueColors_1.rogueColors.peach,
    rogueColors_1.rogueColors.brown,
    rogueColors_1.rogueColors.gray,
    rogueColors_1.rogueColors.blueGray,
];
// export const healthScale = chroma
//   .scale(['red', 'orange', 'yellow', 'green'])
//   .colors(10)
//   .map((c) => chroma(c).num())
exports.healthScale = [
    rogueColors_1.rogueColors.red,
    rogueColors_1.rogueColors.red,
    rogueColors_1.rogueColors.orange,
    rogueColors_1.rogueColors.orange,
    rogueColors_1.rogueColors.yellow,
    rogueColors_1.rogueColors.yellow,
    rogueColors_1.rogueColors.green,
    rogueColors_1.rogueColors.green,
    rogueColors_1.rogueColors.green,
    rogueColors_1.rogueColors.green,
];
exports.fireScale = chroma_js_1.default
    .scale([
    chroma_js_1.default(rogueColors_1.rogueColors.red),
    chroma_js_1.default(rogueColors_1.rogueColors.yellow),
    chroma_js_1.default(rogueColors_1.rogueColors.orange),
])
    .colors(32)
    .map(function (c) { return chroma_js_1.default(c).num(); });
exports.waterScale = chroma_js_1.default
    .scale([
    chroma_js_1.default(rogueColors_1.rogueColors.darkBlue),
    chroma_js_1.default(rogueColors_1.rogueColors.lightBlue),
    chroma_js_1.default(rogueColors_1.rogueColors.light),
])
    .colors(32)
    .map(function (c) { return chroma_js_1.default(c).num(); });
